import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import Primary from './part/primary';
import Steering from './part/steering';
import Support from './part/support';

function Index(props) {
  const newData = props?.data?.map((value, index) => ({ ...value, no: index + 1 }));
  const history = useHistory();

  const cvcPrimary = [];
  const cvcSteering = [];
  const cvcSupport = [];

  newData?.map((item) => {
    if (item.type === 'Primary Process') {
      return cvcPrimary.push(item);
    } if (item.type === 'Steering Governance') {
      cvcSteering.push(item);
    } else if (item.type === 'Support Process') {
      cvcSupport.push(item);
    }
  });

  return (
    <div className="layout_list_cvc">
      <div className="content_list_cvc">
        {cvcSteering.length !== 0 && (
          <div className="content_cvc_steering">
            {cvcSteering?.map((data) => (
              <Steering
                history={history}
                val={data}
                setSelectedData={props?.setSelectedData}
              />
            ))}
          </div>
        )}
        {cvcPrimary?.length !== 0 && (
          <Primary
            cvcPrimary={cvcPrimary}
            history={history}
            setSelectedData={props?.setSelectedData}
          />
        )}
        {cvcSupport?.length !== 0 && (
          <div className="content_cvc_support">
            {cvcSupport?.map((data) => (
              <Support
                val={data}
                history={history}
                setSelectedData={props?.setSelectedData}
              />
            ))}
          </div>
        )}
      </div>
      <div className="square" />
    </div>
  );
}

export default Index;
